import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'tdms-onbording-banner',
    templateUrl: './onbording-banner.component.html',
    styleUrls: ['./onbording-banner.component.scss'],
    standalone: false
})
export class OnbordingBannerComponent implements OnInit {

  @Output() closeOnBoard = new EventEmitter<boolean>();

  isMlaCopied:boolean = false;
  isApaCopied:boolean = false;
  isChicagoCopied:boolean = false;

  constructor() { }

  ngOnInit() {
  }

  copy(style: string) {
    this.isMlaCopied = false;
    this.isApaCopied = false;
    this.isChicagoCopied = false;

    //Select the content based on the style
    const content = document.getElementById(style);
    const range = document.createRange();
    range.selectNode(content);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
    const isCoppied = document.execCommand('copy');
    selection.removeAllRanges(); // Clear selection after copying

    //Copy the selected content to clipboard
    switch(style) {
      case 'MLA':
        this.isMlaCopied = isCoppied;
        setTimeout(() => { this.isMlaCopied = false; }, 2000);
        break;
      case 'APA':
        this.isApaCopied = isCoppied;
        setTimeout(() => { this.isApaCopied = false; }, 2000);
        break;
      case 'Chicago':
        this.isChicagoCopied = isCoppied;
        setTimeout(() => { this.isChicagoCopied = false; }, 2000);
        break;
      default:
        console.error('Unknown style:', style);
    }
    
  }

  close() {
    this.closeOnBoard.emit(true);
  }

}
